(function() {
    window.c24.lp.ac.as = {

        init: function() {
            window.c24.lp.ac.addDefaultQtips('as');

            window.c24.lp.ac.addQTip({
                acType: 'as',
                adjust: true,
                hoverElement: '.product_selection_container label',
                toolTipChild: '.js24Tooltip',
                arrowPosition: 'bottom center',
                parentPosition: 'top center',
            });

            $('.mod24ac.as form').on('submit', function() {
                const ac = $(this).closest('.mod24ac.as');
                const form = $('form', ac);
                const checkedInput = $(form).find('input[type=radio]:checked');
                const url = checkedInput.data('url');

                window._paq.push([
                    'trackEvent',
                    'modification_landing_page',
                    'modification_requested',
                    'type_modificationtype',
                ]);

                form.attr('action', url);
            });
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.as.init();
    });
})();
